import { FeatureEvaluationContext } from './context';
import { FeatureOverrides, FeatureRegistry } from './types';

export interface FeatureEvaluationOptions {
  registry?: FeatureRegistry;
  overrides?: FeatureOverrides;
  evaluationContext?: FeatureEvaluationContext;
}
